import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { borderShape, getColor, getSpace, mq } from '@stylesheets/tools';
import track from '@helper/tracking';

const StyledCard = styled.div`
  display: block;
  position: relative;
  overflow: hidden;
  aspect-ratio: 4 / 5;
  padding: ${getSpace('xs')};

  ${mq('s')} {
    aspect-ratio: 7 / 8;
  }

  ${mq('m')} {
    padding: ${getSpace('s')};
    aspect-ratio: 4 / 3;
  }

  &:before {
    position: absolute;
    content: '';
    inset: 0;
    ${borderShape()}
    width: 100%;
    z-index: 1;
    transform: scale(-1, 1);
    overflow: hidden;
    background-color: ${getColor('white')};
    clip-path: polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px);
  }

  & > div {
    position: relative;
    z-index: 1;
  }
`;

const Card = ({ children, className, href, target, rel }) => {
  return (
    <StyledCard
      className={className}
      as={href ? 'a' : 'div'}
      href={href}
      target={target}
      rel={rel}
      onClick={() => {
        const pathWithoutQueryParams = new URL(href, window.location.origin).pathname;
        track(['trackEvent', 'Archive', 'Article', pathWithoutQueryParams]);
      }}
    >
      <div>{children}</div>
    </StyledCard>
  );
};

Card.propTypes = {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string
};

export default Card;
